import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface CreateTeamMemberState {
  firstName: string,
  lastName: string,
  email: string,
  isTeamMemberCreationPopupOpened: boolean; 
}

// ---------------

const initialState: CreateTeamMemberState = {
    firstName: '', 
    lastName: '',
    email: '',
    isTeamMemberCreationPopupOpened: false, 
};

// ---------------


export const createTeamMemberSlice = createSlice({

  name: 'createTeamMember',

  initialState,

  reducers: {

    setFirstName: (state, action: PayloadAction<string>) => {

        state.firstName = action.payload; 
    },
    setLastName: (state, action: PayloadAction<string>) => { 
        
        state.lastName = action.payload;  
    },
    setEmail: (state, action: PayloadAction<string>) => { 
        
        state.email = action.payload; 
    },
    setIsTeamMemberCreationPopupOpened: (state, action: PayloadAction<boolean>) => { 
        
        state.isTeamMemberCreationPopupOpened = action.payload; 
    },
    resetCreateTeamMember: (state) => { 
        
        state.firstName = '';
        state.lastName = '';
        state.email = '';
        state.isTeamMemberCreationPopupOpened = false; 
    } 

  },

}); 

// ---------------

export const { 
    setFirstName, 
    setLastName, 
    setEmail,  
    setIsTeamMemberCreationPopupOpened, 
    resetCreateTeamMember } = createTeamMemberSlice.actions;

export default createTeamMemberSlice.reducer;